import { useState } from 'react';
import {
  Body,
} from "../../screens/Login/Login.styles"
import { Box, Grid, TextField, Button, InputAdornment, IconButton } from "@mui/material"
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export default function PasswordlessVerify({email, password, errorsEmail, errorsPwd, handlePwdLessChange, resendRequest, isDisabled, timer, userPwdLessLoginMutation, useLoginWithTempPassword}) {
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const handleTogglePassword = () => setShowPassword((show) => !show);
    return(
        <Box sx={{ margin: '0 auto', minHeight: `calc(100vh - 320px)`}}>
            <Grid sx={{ marginBottom: '20px',}}>
                <TextField
                    label={!email ? "Email address" : undefined}
                    value={email}
                    name="email"
                    onChange={handlePwdLessChange}
                    fullWidth
                    required
                    error={!!errorsEmail}
                    helperText={errorsEmail}
                    disabled
                    InputProps={{
                        sx: {
                            backgroundColor: 'white'
                        }
                    }}
                />
            </Grid>
            <Body sx={{fontSize: '16px', fontWeight: 700, color: "#000", margin: '0 0 16px 0',}}>
                We've sent a temporary password to your email address. Please enter it below to continue.
            </Body>
            <Body sx={{fontSize: '12px', color: "#000"}}>
                If you don't see the email within a few minutes, check your spam or junk folder.</Body>
            
            <Grid sx={{ marginBottom: '20px',}}>
                <TextField
                    type={showPassword ? "text" : "password"}
                    label={!password ? "Password" : undefined}
                    value={password}
                    name="password"
                    onChange={handlePwdLessChange}
                    fullWidth
                    required
                    error={!!errorsPwd}
                    helperText={errorsPwd}
                    InputProps={{
                        endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                            aria-label={showPassword ? "Hide password" : "Show password"}
                            onClick={handleTogglePassword}
                            edge="end"
                            >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                        ),
                        sx: {
                            backgroundColor: 'white'
                        }
                    }}
                />
            </Grid>
            <Grid sx={{ marginBottom: '20px',}}>
                <Button
                type="submit"
                variant="contained"
                sx={{
                    textTransform: 'none',
                    width: '100%'
                }}
                disabled={useLoginWithTempPassword.isPending}
                >
                    {useLoginWithTempPassword.isPending? "Logging in..." : "Log in"}
                </Button>

                <Body sx={{fontSize: '12px', color: '#000'}}>Didn't get the password?
                <Button
                    variant="text"
                    onClick={resendRequest}
                    sx={{textTransform: 'capitalize', fontSize: '12px', pt: '4px'}}
                    disabled={userPwdLessLoginMutation.isPending || isDisabled}>
                    Resend
                    </Button>
                    {isDisabled ? `in ${timer} seconds` : ''}
                </Body>
            </Grid>
        </Box>
    );
}
